import { handleActions } from '@housinganywhere/safe-redux';

import { City } from '@ha/api/v2/types';
import { ActionsUnionType, ActionTypes } from '../actions/getCities';

interface State {
  list: City[];
  error: boolean;
}

export const initialState: State = {
  list: [],
  error: false,
};

const cities = handleActions<State, ActionTypes, ActionsUnionType>(
  {
    [ActionTypes.START]: state => ({
      ...state,
      error: false,
    }),
    [ActionTypes.DONE]: (state, { payload }) => ({
      ...state,
      list: payload,
    }),
    [ActionTypes.FAIL]: state => ({
      ...state,
      error: true,
    }),
  },
  initialState,
);
export { cities };
